module.exports = __webpack_public_path__ + "img/zgdx.7cc3d135.png";